var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaSpielspass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#add47f;}.cls-4{fill:#76a12a;}.cls-5{fill:#76b72a;}.cls-6{fill:#cad0d7;}.cls-7{fill:#f4f6f8;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.99,
    y: 8,
    width: 129.63,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.48,43.37a12.29,12.29,0,0,0-4.32-4.19L86.07,9.36a12.73,12.73,0,0,0-12.51,0L21.47,39.18a12.21,12.21,0,0,0-4.32,4.19,12,12,0,0,0-1.89,6.48v59.74a12.38,12.38,0,0,0,6.21,10.67l52.09,29.82a12.73,12.73,0,0,0,12.51,0l52.09-29.82a12.37,12.37,0,0,0,6.2-10.67V49.85a12.11,12.11,0,0,0-1.88-6.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.36,49.85v59.74a12.37,12.37,0,0,1-6.2,10.67L86.07,150.08a12.72,12.72,0,0,1-6.26,1.64v-72l62.67-36.35a12.11,12.11,0,0,1,1.88,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.81,79.72v72a12.66,12.66,0,0,1-6.25-1.64L21.47,120.26a12.38,12.38,0,0,1-6.21-10.67V49.85a12,12,0,0,1,1.89-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.62,124a9.24,9.24,0,0,1-6.6,7.61,4.22,4.22,0,0,1-5.78-4.4,9.17,9.17,0,0,1,6.61-7.59,4.15,4.15,0,0,1,4.14.53,4.2,4.2,0,0,1,1.63,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.21,104.18a9.24,9.24,0,0,0,6.6,7.61,4.22,4.22,0,0,0,5.78-4.41A9.17,9.17,0,0,0,31,99.8a4.2,4.2,0,0,0-5.78,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.48,124a9.23,9.23,0,0,0,6.61,7.61,4.22,4.22,0,0,0,5.78-4.4,9.18,9.18,0,0,0-6.61-7.59A4.2,4.2,0,0,0,57.48,124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.21,69.42A9.24,9.24,0,0,0,31.81,77a4.22,4.22,0,0,0,5.78-4.4A9.17,9.17,0,0,0,31,65a4.2,4.2,0,0,0-5.78,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.48,89.28a9.22,9.22,0,0,0,6.61,7.61,4.22,4.22,0,0,0,5.78-4.4,9.18,9.18,0,0,0-6.61-7.59,4.2,4.2,0,0,0-5.78,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.42,69.42A9.23,9.23,0,0,1,127.81,77a4.22,4.22,0,0,1-5.78-4.4A9.18,9.18,0,0,1,128.64,65a4.2,4.2,0,0,1,5.78,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.52,96.73a9.24,9.24,0,0,1-6.6,7.61,4.22,4.22,0,0,1-5.78-4.4,9.17,9.17,0,0,1,6.6-7.59,4.2,4.2,0,0,1,5.78,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.57,47.66a8.49,8.49,0,0,1-10.47.85,5.5,5.5,0,0,1-1-8.72,8.52,8.52,0,0,1,10.49-.88,5.55,5.55,0,0,1,1,8.75Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaSpielspass);
export default __webpack_public_path__ + "static/media/ka_spiel+spass.23af9d29d1a3b6025d8878e70b6bcc20.svg";
export { ForwardRef as ReactComponent };